// extracted by mini-css-extract-plugin
export default {"wrapper":"ConfirmSteps_wrapper__w8MPZ","inner_container":"ConfirmSteps_inner_container__j-iQg","line":"ConfirmSteps_line__pP-ZG"};